<div [chart]="config" [class.limit-width]="limitWidth"></div>
